import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getReceipt } from 'api/Transaction';

export const useReceipt = ({
  params = {},
  options = {},
  dependencies = [],
  name = 'receipt'
} = {}) => {
  const navigate = useNavigate();
  return useQuery([name, ...dependencies], () => getReceipt(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};
